import React from 'react'

import Compare from 'components/CommonComparisons/components/Compare'
import Grid from 'components/Grid'
import Link from 'components/Link'
import { useEventContext } from 'context/EventContext'

import classes from './PopularComparisons.module.scss'

/** @type {import("./types").default} */
const PopularComparisons = ({ comparisons, gridProps }) => {
  const eventContext = useEventContext({
    engagementComponent: 'product_comparisons',
  })

  return (
    <Grid spacing={2} container>
      {comparisons.map(listing => (
        <Grid
          {...eventContext.addEvent({
            name: 'engagement_cta_compare',
            engagementDetails: 'card_product-vs-product',
            engagementDestination: 'go-to_compare',
            compareProductUuids: `${listing.id}, ${listing.alternative.node.id}`,
          })}
          component={Link}
          href={listing.compareUrl}
          className={classes.link}
          item
          xs={12}
          sm={6}
          lg={4}
          key={listing.id}
          {...gridProps}
        >
          <Compare
            className={classes.item}
            listings={[
              { name: listing.name, logo_url: listing.logoUrl },
              { name: listing.alternative.node.name, logo_url: listing.alternative.node.logoUrl },
            ]}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default PopularComparisons
